import * as AWS from 'aws-sdk/global';
import CONFIG from "../temp/config";

const apigClientFactory = window.apigClientFactory;


export const apigHelperFactory = () => {

  let apigHelper = {};
  
  // Configure the region and identity pool credentials.
  AWS.config.region = CONFIG.schedueAPI.region;
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: CONFIG.schedueAPI.identityPoolId
  });
  
  // Setup the helper
  apigHelper.sessionTokenExpireTime = 0;
  apigHelper.apigClient = {};

  // Define a get Credentials function
  apigHelper.getCredentials = function () {

    return new Promise(function (resolve, reject) {

        // Retrieve new credentials.
      AWS.config.credentials.get(function () {

        // Credentials will be available when this function is called.
        let accessKeyId = AWS.config.credentials.accessKeyId;
        let secretAccessKey = AWS.config.credentials.secretAccessKey;
        let sessionToken = AWS.config.credentials.sessionToken;
        apigHelper.sessionTokenExpireTime = AWS.config.credentials.expireTime;


        apigHelper.apigClient = apigClientFactory.newClient({
          accessKey: accessKeyId,
          secretKey: secretAccessKey,
          sessionToken: sessionToken
        });

        resolve();

      });

    });

  };

  // Define a wrapper for our form post data method
  apigHelper.postFormData = function (payload) {

    let params = {};
    let body = payload;
    let additionalParams = {};

    return new Promise(function (resolve,reject) {

      let methodToCall = function () {
        apigHelper.apigClient.postformdataPost(params, body, additionalParams)
          .then(function (result) {
            resolve(result.data);
          }).catch( function (result) {
          reject(result);
        });
      };

      if (!apigHelper.apigClient || apigHelper.sessionTokenExpireTime < new Date()) {
        apigHelper.getCredentials().then(function () {
          methodToCall();
        });

      } else {
        methodToCall();
      }
    });


  };

  return apigHelper;
};

